/* eslint-disable react/prop-types */
import { FileBrowser } from '@/components/files';

const ContactFiles = ({ contactId }) => {
    return (
        <div className='flex justify-between gap-5 lg:flex-nowrap flex-wrap lg:gap-7.5 mb-5'>
            <div className='card w-full'>
                <div className="card-header">
                    <h3 className="card-title">Contact Files</h3>
                </div>

                <div className="card-body pt-4 pb-3">
                    <FileBrowser fileableType="contact" fileableId={contactId} />
                </div>
            </div>
        </div>
    );
};

export { ContactFiles }
